export const DEFAULT_MOVEMENT_PREFERENCES = ['push', 'pull', 'squat', 'hinge'];
export const DEFAULT_EQUIPMENT_CONTEXT = ['barbell', 'dumbbell', 'machine'];

export function ensureTrainingProfileDefaults(profile) {
  const tp = { ...(profile || {}) };
  if (!Array.isArray(tp.movementPreferences) || !tp.movementPreferences.length) {
    tp.movementPreferences = [...DEFAULT_MOVEMENT_PREFERENCES];
  }
  if (!Array.isArray(tp.equipmentContext) || !tp.equipmentContext.length) {
    tp.equipmentContext = [...DEFAULT_EQUIPMENT_CONTEXT];
  }
  return tp;
}
